import { h } from "@stencil/core";
import { PrefillData } from "../../../api/publicApi/createCase";
import { FormStore } from "./form-store";
import { ApiStore } from "../api-store";
import { TranslationKey } from "../../../utils/loadTranslations";

interface NotificationTypeSelectProps {
    t: (key: string) => string;
    prefillData: PrefillData | null;
    formStore: FormStore;
    apiStore: ApiStore;
}

export const NotificationTypeSelect = ({ t, prefillData, apiStore, formStore }: NotificationTypeSelectProps) => {
    const { notificationTypes } = apiStore.state;
    const { selectedNotificationType } = formStore.state;
    return (
        <ux-select
            required
            label={t("field.reason.label")}
            data-validation-required--msg={t("validation.requiredField")}
            name="notificationType"
            onUxChange={(event) => {
                formStore.state.selectedNotificationType = Number(event.detail.value);
            }}
            disabled={prefillData?.notificationType}
        >
            <option value="" selected={!prefillData?.notificationType} disabled>
                {t("select.placeholder")}
            </option>
            {notificationTypes.map((notificationType) => (
                <option
                    key={String(notificationType.LabelKey)}
                    value={notificationType.Id}
                    selected={notificationType.Id === selectedNotificationType}
                >
                    {t(`notificationType.${notificationType.LabelKey}` as TranslationKey)}
                </option>
            ))}
        </ux-select>
    );
};
